import { render, staticRenderFns } from "./ExplainCell.vue?vue&type=template&id=1dd8a51e&scoped=true"
import script from "./ExplainCell.vue?vue&type=script&lang=js"
export * from "./ExplainCell.vue?vue&type=script&lang=js"
import style0 from "./ExplainCell.vue?vue&type=style&index=0&id=1dd8a51e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dd8a51e",
  null
  
)

export default component.exports